import { ToastType } from '@components/toast';
import { QuoteCustomerInviteByQuoteIdPostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useCreateQuoteCustomerInvite = () => {
  const client = useClient();

  const { enqueueSnackbar } = useSnackbar();

  const result = useMutation({
    mutationFn: async (quoteId: string) =>
      client
        .post(`quote/${quoteId}/quote-customer-invite`, { json: {} })
        .json<QuoteCustomerInviteByQuoteIdPostResponse>(),
    onSuccess: (data) => {
      return data;
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(
        e,
        'Link could not be copied. Please reach out to LIO Support for assistance.',
      );
      enqueueSnackbar(message, {
        variant: ToastType.Error,
      });
    },
  });
  return { ...result, createQuoteCustomerInvite: result.mutateAsync };
};
